if (!customElements.get('adev-overlay')) {
    customElements.define('adev-overlay', class adevOverlay extends HTMLElement {
        constructor() {
            super();
        }

        close() {
            document.documentElement.classList.remove('is--overlay-on');

            document.dispatchEvent(new CustomEvent('adev:overlay:closed'));
        }

        connectedCallback() {
            this.addEventListener('click', this.close.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.close.bind(this));
        }

    });
}

if (!customElements.get('adev-mobile-menu')) {
    customElements.define('adev-mobile-menu', class adevMobileMenu extends HTMLElement {
        constructor() {
            super();

            this.closeEl = this.querySelector('[data-adev-mobile-menu="close"]');
            this.closeEl.addEventListener('click', this.close.bind(this));

            document.addEventListener('adev:overlay:closed', this.close.bind(this));
        }

        open() {
            this.classList.add('is--active');
            document.documentElement.classList.add('is--overlay-on');
        }

        close() {
            this.classList.remove('is--active');
            document.documentElement.classList.remove('is--overlay-on');
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-mobile-menu="a"]').forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    
                    link.classList.toggle('is--active');
                });
            });
        }

        disconnectedCallback() {
            
        }

    });
}

if (!customElements.get('adev-accordion')) {
    customElements.define('adev-accordion', class adevAccordion extends HTMLElement {
        constructor() {
            super();

            this.headerEl = this.querySelector('[data-adev-accordion="header"]');
            this.contentEl = this.querySelector('[data-adev-accordion="content"]');
        }

        open(){
            this.classList.add('is--active');
        }

        close() {
            this.classList.remove('is--active');
        }

        toggle() {
            this.classList.toggle('is--active');
        }

        connectedCallback() {
            this.headerEl.addEventListener('click', this.toggle.bind(this));
        }

        disconnectedCallback() {
            this.headerEl.removeEventListener('click', this.toggle.bind(this));
        }

    });
}

if (!customElements.get('adev-product-card')) {
    customElements.define('adev-product-card', class adevProductCard extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-product-card="atc"]').forEach((button) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();

                    const variantId = button.getAttribute('data-id');

                    button.classList.add('is--loading');
                    
                    const formData = new FormData();
                    formData.append('id', variantId);
                    formData.append('quantity', 1);

                    formData.append('sections', 'cart-drawer,cart-icon-bubble');
                    formData.append('sections_url', window.location.pathname);

                    fetch(`${routes.cart_add_url}.js`, {
                        method: 'POST',
                        body: formData
                    })
                    .then((response) => {
                        return response.json();
                    })
                    .then((data) => {
                        const isCartPage = window.location.pathname.includes('/cart');

                        if (isCartPage) {
                            window.location.reload();
                            return;
                        }

                        button.classList.remove('is--loading');
                        
                        document.dispatchEvent(new CustomEvent('adev:cart:updated', { detail: data }));
                    })
                    .catch((error) => {
                        button.classList.remove('is--loading');
                        console.error('Error removing bundle items:', error);
                    });

                });
            });
        }

    });
}

document.addEventListener('adev:cart:updated', (event) => {
    const cartData = event.detail;

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
        cartDrawerEl.renderContents(cartData);

        let isEmpty = document.querySelectorAll('cart-drawer-items.is-empty').length > 0;

        if (isEmpty) {
            cartDrawerEl.classList.add('is-empty');
        } else {
            cartDrawerEl.classList.remove('is-empty');
        }
    }
});

window.adev = window.adev || {};

window.adev.Utils = window.adev.Utils || {};

window.adev.Utils.debounce = function(func, timeout=300) {
    let timer;return(...args)=>{clearTimeout(timer);timer=setTimeout(()=>{func.apply(this,args)},timeout)}
}